import React from 'react'

import { Chip, type ChipProps } from './Chip'
import { ListBox, type Props as ListBoxProps } from './internal/ListBox'
import type { MenuOptionVariantSelectable } from './MenuOption'

type Props<
  TOption extends MenuOptionVariantSelectable = MenuOptionVariantSelectable
> = Omit<ListBoxProps<TOption>, 'children' | 'label' | 'placeholder'> & {
  /**
   * Sets the `label` prop on the `Chip` component.
   */
  label: ChipProps['label']
  /**
   * Sets the `accessory` prop on the `Chip` component.
   */
  accessory?: ChipProps['accessory']
  /**
   * Sets the `selected` prop on the `Chip` component.
   */
  selected?: ChipProps['selected']
}

/**
 * Work in progress, API is expected to change.
 *
 * The `ChipMenu` is a dropdown that allows the user to select from a list of options.
 * It is similar to the `SelectMenu` but uses a `Chip` as the trigger element.
 */
export function ExperimentalChipMenu<
  TOption extends MenuOptionVariantSelectable = MenuOptionVariantSelectable
>({
  accessory,
  label,
  selected,
  state = 'default',
  ...listBoxProps
}: Props<TOption>) {
  return (
    <ListBox<TOption> {...listBoxProps}>
      {({ ref, ...toggleProps }) => (
        <Chip
          {...toggleProps}
          accessory={accessory}
          innerRef={ref}
          label={label}
          selected={selected}
          state={state === 'disabled' ? 'disabled' : 'default'}
          type={state === 'disabled' ? 'presentation' : 'button'}
        />
      )}
    </ListBox>
  )
}
